import { QueryClient } from '@tanstack/react-query';

import { isApiError } from './problem';

/** Los 4xx no se reintentan (el resultado no cambia); red caída o 5xx, hasta 2 reintentos. */
export function shouldRetry(failureCount: number, error: unknown): boolean {
  if (isApiError(error) && error.status >= 400 && error.status < 500) return false;
  return failureCount < 2;
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        // Largo para que la persistencia offline (E1-21) pueda rehidratar datos de horas atrás.
        gcTime: 24 * 60 * 60 * 1000,
        retry: shouldRetry,
        retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
        refetchOnWindowFocus: false,
      },
      mutations: {
        // Votar o calificar dos veces por un reintento automático nunca es aceptable.
        retry: false,
      },
    },
  });
}

export const queryClient = createQueryClient();
